import { ToastModule } from 'ng-uikit-pro-standard';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA, Injectable } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routes.service';

import { HttpClientModule, HTTP_INTERCEPTORS  } from '@angular/common/http';
import { ApiInterceptor } from 'app/helpers/api.interceptor';

import { ViewsModule } from './views/views.module';
import { SharedModule } from './shared/shared.module';
import { MDBSpinningPreloader } from 'ng-uikit-pro-standard';

import { ErrorModule } from './views/errors/error.module';

import { Globals } from 'app/services/globals';
import { NgxCurrencyModule } from "ngx-currency";

// main layout
import { NavigationModule } from './main-layout/navigation/navigation.module';
import { IndexComponent } from './website/components/index/index.component';
import { WebsiteComponent } from './website/website.component';
import { SiteNavbarComponent } from './website/components/navbar/navbar.component';
import { SiteFooterComponent } from './website/components/site-footer/site-footer.component';
import { HowWorksComponent } from './website/components/how-works/how-works.component';
import { MoreFeatureComponent } from './website/components/more-feature/more-feature.component';
import { FeatureSectionComponent } from './website/components/feature-section/feature-section.component';
import { CarouselCaptionComponent } from './website/components/carousel-caption/carousel-caption.component';
import { UseCaseComponent } from './website/components/use-case/use-case.component';
import { SitePricingComponent } from './website/components/pricing/pricing.component';
import { FaqComponent } from './website/components/faq/faq.component';
import { QuestionnaireComponent } from './website/components/questionnaire/questionnaire.component';
import { GetStartedComponent } from './website/components/get-start/get-started.component';
import { GoPaperlessComponent } from './website/components/go-paperless/go-paperless.component';
import { DocumentManagementComponent } from './website/components/document-management/document-management.component';
import { AutomateWorkflowsComponent } from './website/components/automate-workflows/automate-workflows.component';
import { DataReportsAndAnalyticsComponent } from './website/components/data-reports-and-analytics/data-reports-and-analytics.component';

import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { WorkflowManagementComponent } from './website/landing-pages/workflow-management/workflow-management.component';
import { ForDocumentManagementComponent } from './website/landing-pages/for-document-management/for-document-management.component';
import { EnterpriseContentManagementComponent } from './website/landing-pages/enterprise-content-management/enterprise-content-management.component';
import { BusinessProcessManagementComponent } from './website/landing-pages/business-process-management/business-process-management.component';
import { FormsAutomationComponent } from './website/landing-pages/forms-automation/forms-automation.component';

import { PrivacyPolicyComponent } from './website/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './website/terms-of-service/terms-of-service.component';
import { CookieStatementComponent } from './website/cookie-statement/cookie-statement.component';
import { CalculateRoiPageComponent } from './website/components/calculate-roi-page/calculate-roi-page.component';
import { RoiCalculatorComponent } from './website/components/roi-calculator/roi-calculator.component';
import { FieldsPickerModalComponent } from './views/fields-picker-modal/fields-picker-modal.component';
import { CronEditorModule } from '@zapinfo/ngx-cron-editor';

import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { MetadataEditorModalComponent } from './views/metadata-editor-modal/metadata-editor-modal.component';

declare var Hammer: any;

@Injectable({ providedIn: 'root' })
export class MyHammerConfig extends HammerGestureConfig {
  overrides = <any> {
    'pan': { direction: Hammer.DIRECTION_All },
    'swipe': { direction: Hammer.DIRECTION_VERTICAL },
  };

  buildHammer(element: HTMLElement) {
    const mc = new Hammer(element, {
      touchAction: 'auto',
          inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput,
          recognizers: [
            [Hammer.Swipe, {
              direction: Hammer.DIRECTION_HORIZONTAL
            }]
          ]
    });
    return mc;
  }
}

@NgModule({
  declarations: [
    AppComponent,
    IndexComponent,
    WebsiteComponent,
    SiteNavbarComponent,
    SiteFooterComponent,
    HowWorksComponent,
    MoreFeatureComponent,
    FeatureSectionComponent,
    CarouselCaptionComponent,
    UseCaseComponent,
    SitePricingComponent,
    FaqComponent,
    QuestionnaireComponent,
    GetStartedComponent,
    GoPaperlessComponent,
    DocumentManagementComponent,
    AutomateWorkflowsComponent,
    DataReportsAndAnalyticsComponent,
    WorkflowManagementComponent,
    ForDocumentManagementComponent,
    EnterpriseContentManagementComponent,
    BusinessProcessManagementComponent,
    FormsAutomationComponent,
    PrivacyPolicyComponent,
    TermsOfServiceComponent,
    CookieStatementComponent,
    CalculateRoiPageComponent,
    RoiCalculatorComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NavigationModule,
    AppRoutingModule,
    RouterModule,
    FormsModule,
    SharedModule,
    ViewsModule,
    ErrorModule,
    ToastModule.forRoot(),
    ReactiveFormsModule,
    NgxCurrencyModule,
    CronEditorModule,
    NgxDaterangepickerMd.forRoot()
  ],
  entryComponents: [
    FieldsPickerModalComponent,
    MetadataEditorModalComponent
  ],
  providers: [
    MDBSpinningPreloader,
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: MyHammerConfig
    }
  ],
  bootstrap: [AppComponent],
  schemas: [ NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
